const Option = () => null;
Option.isSelectOption = true;
Option.displayName = 'PfAutoCompleteOption';
export default Option;
